import { flexCenter } from "../styles/mixins";
import { createStyles, makeUiStyles, Theme } from "../styles/styles";
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    ...flexCenter(),
    flexDirection: 'column',
    marginTop: 64,
    paddingTop: 0,
  },
  wrapper: {
    margin: '0 auto',
    maxWidth: theme.space.singleColumnMaxWidth,
  },
  icon: {
    [theme.breakpoints.down('md')]: {
      maxWidth: 308
    }
  }
}), { name: 'NotFoundCard', index: StylesIndexInjections.UI_MOLECULES });
